// Persistência local de likes/follows do usuário (sem auth).
// Chaves: liked_videos, liked_cds, liked_dvds, liked_musics, followed_artists.

const KEY = {
  videos: "ap_liked_videos",
  cds: "ap_liked_cds",
  dvds: "ap_liked_dvds",
  musics: "ap_liked_musics",
  artists: "ap_followed_artists",
};

function readSet(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return new Set();
    return new Set(JSON.parse(raw));
  } catch {
    return new Set();
  }
}

function writeSet(key, set) {
  try {
    localStorage.setItem(key, JSON.stringify([...set]));
  } catch {}
}

export function isLiked(kind, id) {
  return readSet(KEY[kind]).has(id);
}

export function toggleLike(kind, id) {
  const s = readSet(KEY[kind]);
  if (s.has(id)) s.delete(id);
  else s.add(id);
  writeSet(KEY[kind], s);
  return s.has(id);
}

export function isFollowing(artistName) {
  if (!artistName) return false;
  return readSet(KEY.artists).has(artistName.toLowerCase().trim());
}

export function toggleFollow(artistName) {
  if (!artistName) return false;
  const k = artistName.toLowerCase().trim();
  const s = readSet(KEY.artists);
  if (s.has(k)) s.delete(k);
  else s.add(k);
  writeSet(KEY.artists, s);
  return s.has(k);
}

export function getFollowedArtists() {
  return [...readSet(KEY.artists)];
}
